// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import http from "@/plugins/http";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueLazyload from "vue-lazyload";
import router from "./router";
import store from "./store/index";
Vue.config.productionTip = false;
const {
  Message,
  Popover,
  Pagination,
  Dialog,
  Button,
  Tooltip,
  Radio,
  Select,
  Option,
  Checkbox,
  Switch,
  Upload,
  Slider,
  Row,
  Col,
  Icon,
  Loading,
  MessageBox,
  Input,
  Scrollbar,
  Form,
  FormItem,
} = ElementUI;
Vue.prototype.$ELEMENT = {
  zIndex: 9999,
};
Vue.prototype.$message = Message;
Vue.prototype.$http = http;
Vue.use(Popover);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Tooltip);
Vue.use(Radio);
Vue.use(Select);
Vue.use(Option);
Vue.use(Icon);
Vue.use(Checkbox);
Vue.use(Switch);
Vue.use(Upload);
Vue.use(Slider);
Vue.use(Row);
Vue.use(Col);
Vue.use(Input);
Vue.use(Scrollbar);
Vue.use(Form);
Vue.use(FormItem);
Vue.prototype.$confirm = MessageBox.confirm;
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;

Vue.directive("force-input-number", {
  update: function (el) {
    try {
      if (!el.value) return false;
      el.value = el.value.replace(/\D/g, "");
      el.dispatchEvent(new Event("input"));
    } catch (e) {
      console.log(e);
    }
  },
});
// 配置懒加载
Vue.use(VueLazyload, {
  loading: require("../src/assets/images/index/loading.png"),
  attempt: 2,
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App,
  },
  template: "<App/>",
});
